const defaultProperties = {
  show: true,
  maxWidth: 200,
  height: 1,
  backgroundColor: '#E0E0E0',
  align: 'center',
};
export default (properties = {}) => {
  const finalProperties = {
    ...defaultProperties,
    ...properties,
  };
  const margin =
    finalProperties.align === 'center' ? '0 auto' : finalProperties.align === 'left' ? '0 auto 0 0' : '0 0 0 auto';
  return `
    <div data-show="${
      finalProperties.show ? 'true' : 'false'
    }" data-attribute="divider-primary" class="divider-primary" style="display: ${
    finalProperties.show ? 'block' : 'none'
  }">
        <div data-background="${finalProperties.backgroundColor}" data-height="${finalProperties.height}" data-align="${
    finalProperties.align
  }" data-max-width="${
    finalProperties.maxWidth
  }" data-attribute="divider-primary-line" class="divider-primary-line" style="background-color: ${
    finalProperties.backgroundColor
  }; height: ${finalProperties.height}px; margin: ${margin}; max-width: ${finalProperties.maxWidth}px;"></div>
    </div>
    `;
};
